import { Display10, Paragraph30 } from '@squareup/dex-ui-shared-base';
import {
  MarketDialog,
  MarketButtonGroup,
  MarketButton,
  MarketFooter,
  MarketHeader,
} from '@squareup/dex-ui-shared-market';
import React, { FC } from 'react';

import styles from './api-explorer-share-api-dialog.module.css';

interface Props {
  onClose(): void;
}

const strings = {
  title: 'Sharing a request',
  description:
    'Copy your defined API Explorer endpoint and request parameters as a shareable link. For security purposes, access tokens will not be included.',
  confirmButton: 'Okay',
};

const ApiExplorerShareApiDialog: FC<Props> = ({ onClose }) => {
  return (
    <MarketDialog
      className={styles['dialog'] as string}
      onMarketDialogDismissed={onClose}
    >
      <MarketHeader>
        <Display10>{strings.title}</Display10>
      </MarketHeader>
      <Paragraph30>{strings.description}</Paragraph30>
      <MarketFooter>
        <MarketButtonGroup alignment="fill">
          <MarketButton
            onClick={onClose}
            rank="primary"
            trackingId="api-explorer-share-request-confirm-button"
          >
            {strings.confirmButton}
          </MarketButton>
        </MarketButtonGroup>
      </MarketFooter>
    </MarketDialog>
  );
};

export { ApiExplorerShareApiDialog };
